import axios from "axios";
import { BASE_URL } from "./config";


export const submitSociety = async (textData, imageFile) => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams(textData).toString();
  const body = new FormData();
  if (imageFile) {
    body.append("societyImage", imageFile);
  }
  return axios.post(`${BASE_URL}/api1/add-society?${params}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSociety = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found. Please log in.");

    const response = await axios.get(`${BASE_URL}/api1/get-all-society`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching societies:", error);
    throw error;
  }
};

export const submitAdmin = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found. Please log in.");
    console.log("admin token" + token);

    const params = new URLSearchParams(formData);

    const response = await axios.post(
      `${BASE_URL}/api1/add-society-admin`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error submitting society:", error);
    throw error;
  }
};

export const getAdmin = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found. Please log in.");

    const response = await axios.get(`${BASE_URL}/api1/get-society-admin`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching societies:", error);
    throw error;
  }
};

export const getAdminlogin = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token not found. Please log in.");

    const response = await axios.get(
      `https://back.devaccounts.com/api1/get-login-admin-details`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching societies:", error);
    throw error;
  }
};
